import {useState} from 'react';

import A11yHelper from './A11yHelper';
import CookieConsent from './CookieConsent';

const A11yAndCookieConcent = () => {
  const [showBanner, setShowBanner] = useState(false);

  return (
    <>
      {/* @ts-expect-error A11yHelper.js */}
      <A11yHelper cookiesConcentBannerShown={showBanner} />
      <CookieConsent showBanner={showBanner} setShowBanner={setShowBanner} />
    </>
  );
};

export default A11yAndCookieConcent;
